"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberStatusEnum = void 0;
var MemberStatusEnum;
(function (MemberStatusEnum) {
    MemberStatusEnum["NEW"] = "new";
    MemberStatusEnum["ACTIVE"] = "active";
    MemberStatusEnum["INVITED"] = "invited";
})(MemberStatusEnum = exports.MemberStatusEnum || (exports.MemberStatusEnum = {}));
